// extracted by mini-css-extract-plugin
export default {"image":"PageHeadImage-module_image_c59f3"};